import React, { useRef } from 'react'

export const useCarousel = ({ children }) => {
  const sliderRef = useRef(null)

  const handleGoTo = (i) => {
    pauseVideo()
    sliderRef.current.slickGoTo(i)
  }

  const handleNextSlide = () => {
    pauseVideo()
    sliderRef.current.slickNext()
  }

  const handlePrevSlide = () => {
    pauseVideo()
    sliderRef.current.slickPrev()
  }

  const pauseVideo = () => {
    const videoRef = sliderRef.current.innerSlider.list
      ?.querySelector('.slick-active')
      ?.querySelector('video')

    videoRef?.pause()

    const youtubeRef = sliderRef.current.innerSlider.list
      ?.querySelector('.slick-active')
      ?.querySelector('iframe')

    if (youtubeRef) {
      const iframeSrc = youtubeRef.src
      youtubeRef.src = iframeSrc
    }
  }
  const listeners = {
    handleNextSlide,
    handlePrevSlide,
    handleGoTo,
  }

  return {
    sliderRef,
    listeners,
  }
}

export default useCarousel
